// removed by extract-text-webpack-plugin
module.exports = {"new-timetable-button":"style__new-timetable-button___3-V9E","timetable":"style__timetable___1Z8hE","timetable-heading":"style__timetable-heading___Tt4Yk","timetable-table":"style__timetable-table___3zHDJ","timetable-action-panel":"style__timetable-action-panel___3WKwB","timetable-action":"style__timetable-action___Do1Dp","timetable-name--to-delete":"style__timetable-name--to-delete___vYgEu"};


//////////////////
// WEBPACK FOOTER
// ./components/TimetableList/style.scss
// module id = 1337
// module chunks = 0